import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetBaseUrl } from 'app/helper/getBaseUrl';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class UserFeedbackSender {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient,) { }

    send(ticketId: number, satisfactedValue: number, note: string): Promise<Object> {
        return this.http.post(this.baseUrl + '/userFeedback/', {
            id_ticket: ticketId,
            value: satisfactedValue.toString(),
            note
        }).toPromise();
    }
}